angular.module('picmonic-common')
    .factory("ReferralDataService", [function() {
        return {
            referral: {}
        }
    }]);